import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Toast } from '../Toast';
import { Typography } from "@material-ui/core";
import { Button } from '../Button';
import { CardNotificacao } from '../CardNotificacao/CardNotificacao';
import { GrDocumentPdf } from 'react-icons/gr';
import { b64toBlob } from '../../../util/fieldMasks';
import { useRelatorios } from '../../../contexts/Relatorios';
import { useHistory } from 'react-router-dom';
import ReactLoading from 'react-loading';
import moment from 'moment';
import { useModals } from '../../../contexts/Modals';

interface propsModalNotificacao {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    notificacoes: any
}

export function ModalNotificacao(props: propsModalNotificacao) {
    const { updateNotifi, deleteNotifi, buscarNotifications } = useRelatorios();
    const [loadingArray, setLoadingArray] = useState<number[]>([]);
    const forceUpdate = React.useReducer(() => ({}), {})[1] as () => void //Force re-render da página;
    const history = useHistory();

    function handleCloseModal() {
        props.setShowModal(false);
    }

    function abrirAnexo(id: number) {
        let tempAddArrayLoading = loadingArray;
        //Adicionando na lista
        tempAddArrayLoading.push(id);
        setLoadingArray(tempAddArrayLoading);
        forceUpdate();
        showFile(id);
    }

    async function showFile(id: number) {
        let url = "#";
        buscarNotifications(id, history)
            .then((res) => {
                updateNotifi(id, history);
                url = window.URL.createObjectURL(b64toBlob(res[0].anexo, "application/pdf", 512));
                window.open(url, "_blank");

                //Removendo da lista
                let tempAddArrayLoading = loadingArray;
                for (let index = 0; index < tempAddArrayLoading.length; index++) {
                    if (tempAddArrayLoading[index] === id)
                        tempAddArrayLoading.splice(index, 1);
                }
                setLoadingArray(tempAddArrayLoading);
                forceUpdate();
            })
            .catch((err) => {
                Toast("error", err);
            })
    }

    return (
        <Modal
            show={props.showModal}
            onHide={() => handleCloseModal()}
            dialogClassName="modal-90w"
            animation={true}
            centered={true}
            size={"lg"}
            style={{ overflow: 'hidden' }}
        >
            {props.showModal === true &&
                <>
                    <Modal.Header closeButton className="modal-header-adicionar-itens-pedido">
                        <Modal.Title className="detalhe-adicionar-itens-titulo-modal">
                            <Typography className="detalhe-adicionar-itens-texto-titulo">Notificações</Typography>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body
                        style={{ overflow: 'hidden' }}>
                        <div className="modal-container-additens-area">
                            <div className="modal-notificacoes-table-area">
                                {props.notificacoes !== undefined && props.notificacoes.length > 0 ?
                                    <ul>
                                        {props.notificacoes.map((element: any, index: number) => {
                                            //console.log(element);
                                            // Create Blog View Link
                                            let text = "";
                                            let icone = <></>;
                                            if (element.tem_anexo === 1) {
                                                icone = <button type='button' className='btn-icon-notifi' onClick={() => abrirAnexo(element.id)}><GrDocumentPdf size={27} /></button>
                                            } else {
                                                icone = <></>;
                                            }
                                            if (element.descricao !== undefined) {
                                                if (element.descricao.includes("Não houve informações")) {
                                                    text = element.modelo + " - Não houve informações";
                                                    icone = <></>;
                                                } else if (element.descricao.length > 60) {
                                                    text = element.descricao.substring(0, 60) + "...";
                                                } else {
                                                    text = element.descricao;
                                                }
                                            } else {
                                                text = "Uma nova notificação";
                                            }
                                            return (
                                                <CardNotificacao
                                                    key={`card_notifi_${index}`}
                                                    text={text}
                                                    icone={loadingArray.includes(element.id) ? <ReactLoading type={"bars"} color={"#0252a8"} height={15} width={30} /> : icone}
                                                    dataNotifi={moment(new Date(element.data)).utc().format("DD/MM/YYYY HH:mm:ss")}
                                                    visualizado={element.visualizado}
                                                    onDelete={() => deleteNotifi(element.id, history)}
                                                />
                                            )
                                        })}
                                    </ul>
                                    :
                                    <label className={"modal-additens-title"} htmlFor="modal-additens-title"><b>Não há nenhuma notificação no momento.</b></label>
                                }
                            </div>
                            <div className="modal-additens-footer-itens-area">
                                <div className="modal-additens-footer-info-area">
                                </div>
                                <div className="modal-additens-footer-addbotoes-area">
                                    <Button onClick={() => handleCloseModal()} classBtn={"btn-footer-novo-pedido color-red"}>Fechar</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </>
            }
        </Modal>
    );
}